// src/Pages/Orgs.js
import React, { useEffect, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import OrgsList from '../Components/Orgslist.js';
import '../CSS/Orgs.css';
import useIsMobile from '../Components/UseIsMobile.js';
import EmailFormModal from '../Components/EmailOrgsModal.js';

const Orgs = () => {
  const [orgs, setorgs] = useState([]);
  const [top25, settop25] = useState([]);
  const [access_token, setAccessToken] = useState('');

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSector, setSelectedSector] = useState('');
  const [selectedLetter, setSelectedLetter] = useState('');

  const isMobile = useIsMobile();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSearch = (event) => setSearchTerm(event.target.value);
  const handleSectorChange = (event) => setSelectedSector(event.target.value);
  const handleLetterChange = (letter) => setSelectedLetter(letter);
  const setSector = (sector) => setSelectedSector(sector);

  const clearFilters = () => {
    setSearchTerm('');
    setSelectedSector('');
    setSelectedLetter('');
  };

  useEffect(() => {
    fetch('/api/hello')
      .then((response) => response.json())
      .then((data) => {
        setorgs(data.orgs);
        settop25(data.orgs.filter((org) => org.fields._x0054_op25));
        setAccessToken(data.accessToken);
      })
      .catch((error) => console.error('Error fetching reports data:', error));
  }, []);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const powerBiReport = (
    <PowerBIEmbed
      embedConfig={{
        type: 'report',
        id: '5d14b040-30bd-4655-a270-334e4afaf546',
        embedUrl:
          'https://app.powerbi.com/reportEmbed?reportId=5d14b040-30bd-4655-a270-334e4afaf546&groupId=8462ee1f-e8db-4f03-bba9-021eabab566f',
        accessToken: access_token,
        tokenType: models.TokenType.Aad,
        pageName: 'ReportSection707abbb7419243da4c42',
        settings: {
          panes: { filters: { expanded: false, visible: false } },
          navContentPaneEnabled: false,
          background: models.BackgroundType.Transparent,
        },
      }}
      eventHandlers={
        new Map([
          ['loaded', () => console.log('Report loaded')],
          ['rendered', () => console.log('Report rendered')],
          ['error', (event) => console.log(event.detail)],
        ])
      }
      cssClassName="reportClassOrgs"
      getEmbeddedComponent={(embeddedReport) => {
        window.report = embeddedReport;
      }}
    />
  );

  return (
    <div className="orgs">
      {!isMobile && (
        <>
          <h1>Activist Organizations</h1>

          <div className="orgs-filter-bar">
            <div className="orgs-filter-card">
              <div className="orgs-filter-header">
                <div>
                  <h2 className="orgs-filter-title">Search & Filters</h2>
                  <div className="orgs-filter-subtitle">
                    Find an organization by name, sector, or letter.
                  </div>
                </div>

                <button className="orgs-btn orgs-btn-secondary" onClick={clearFilters}>
                  Clear Filters
                </button>
              </div>

              <div className="orgs-filter-grid">
                <div className="orgs-filter-group">
                  <label className="orgs-label">Name</label>
                  <input
                    className="orgs-input"
                    type="text"
                    placeholder="Search by name…"
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>

                <div className="orgs-filter-group">
                  <label className="orgs-label">Sector</label>

                  <div className="orgs-sector-pills" role="radiogroup" aria-label="Sector">
                    <button
                      type="button"
                      className={`orgs-pill ${selectedSector === 'AR' ? 'active' : ''}`}
                      onClick={() => setSector('AR')}
                    >
                      Animal Rights
                    </button>

                    <button
                      type="button"
                      className={`orgs-pill ${selectedSector === 'ES' ? 'active' : ''}`}
                      onClick={() => setSector('ES')}
                    >
                      Energy Sector
                    </button>

                    <button
                      type="button"
                      className={`orgs-pill ${selectedSector === 'PHARMA' ? 'active' : ''}`}
                      onClick={() => setSector('PHARMA')}
                    >
                      Pharma
                    </button>

                    <button
                      type="button"
                      className={`orgs-pill ${selectedSector === '' ? 'active' : ''}`}
                      onClick={() => setSector('')}
                      title="All sectors"
                    >
                      All
                    </button>
                  </div>

                  <div className="orgs-hidden-radios" aria-hidden="true">
                    {['AR', 'ES', 'PHARMA'].map((sector) => (
                      <input
                        key={sector}
                        type="radio"
                        value={sector}
                        checked={selectedSector === sector}
                        onChange={handleSectorChange}
                      />
                    ))}
                  </div>
                </div>
              </div>

              <div className="orgs-cta">
                <div className="orgs-cta-text">
                  <div className="orgs-cta-title">Don’t see a group you’re interested in?</div>
                  <div className="orgs-cta-subtitle">Request coverage and we’ll take a look.</div>
                </div>

                <button className="orgs-btn orgs-btn-primary" onClick={handleOpenModal}>
                  Contact Us
                </button>
              </div>
            </div>
          </div>

          <div className="orgs-main-layout">
            <div className="all-groups">
              <h1>Groups A-Z</h1>

              <div className="alphabet-filter">
                <span
                  className={`letter ${selectedLetter === '' ? 'selected' : ''}`}
                  onClick={() => handleLetterChange('')}
                  title="All"
                >
                  #
                </span>

                {'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map((letter) => (
                  <span
                    key={letter}
                    className={`letter ${selectedLetter === letter ? 'selected' : ''}`}
                    onClick={() => handleLetterChange(letter)}
                  >
                    {letter}
                  </span>
                ))}
              </div>

              <div className="orgs-scroll-area">
                <OrgsList
                  orgs={orgs}
                  searchTerm={searchTerm}
                  sectorSelected={selectedSector}
                  selectedLetter={selectedLetter}
                  handleSearch={handleSearch}
                  handleSectorChange={handleSectorChange}
                />
              </div>
            </div>

            <div className="top-25">
              <h1>Groups By Activity</h1>
              <style>{`iframe { border: none; }`}</style>
              <div className="powerbi-wrapper">
                {powerBiReport}
              </div>
            </div>
          </div>
        </>
      )}

      {isMobile && (
        <div>
          <details className="filter-section">
            <summary className="filter-header">🔍 Search & Filters</summary>

            <div className="filter-content">
              <label>
                Name Search:
                <input
                  type="text"
                  placeholder="Search by Name"
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </label>

              <label>Sector Filter:</label>

              <div className="mobile-sector-filter">
                {['AR', 'ES', 'PHARMA'].map((sector) => (
                  <label key={sector}>
                    <input
                      type="radio"
                      value={sector}
                      checked={selectedSector === sector}
                      onChange={handleSectorChange}
                    />
                    {sector === 'AR'
                      ? 'Animal Rights'
                      : sector === 'ES'
                      ? 'Energy Sector'
                      : 'Pharma'}
                  </label>
                ))}
              </div>

              <button onClick={clearFilters} className="clear-button">
                Clear
              </button>

              <button onClick={handleOpenModal} className="orgs-mobile-contact">
                Contact Us
              </button>
            </div>
          </details>

          <div className="top-25">
            <h1>Groups By Activity</h1>
            {powerBiReport}
          </div>

          <h1>Groups A-Z</h1>
          <OrgsList
            orgs={orgs}
            searchTerm={searchTerm}
            sectorSelected={selectedSector}
            selectedLetter={selectedLetter}
          />
        </div>
      )}

      <EmailFormModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
};

export default Orgs;